// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Factoids__Wrapper_2Tl7v","Factoid":"Factoids__Factoid_3-uBY","Name":"Factoids__Name_2vT-g","Value":"Factoids__Value_1EQ8f"};